let runtimeConfig:any = null;
let configLoaded:boolean = false;
// Load config from /config.json at startup
export const loadConfig = async () => {
  if (!runtimeConfig) {
    try {
      const response = await fetch('/config.json');
      runtimeConfig = await response.json();
      configLoaded = true;
    } catch (error) {
      console.error('Failed to load runtime config:', error);
      // Fallback to build-time env vars if config.json fails
      runtimeConfig = {};
      configLoaded = true;
    }
  }
  return runtimeConfig;
};

const checkConfigLoaded = (property:string) => {
  if (!configLoaded) {
    console.error(`🚨 Config.${property} accessed before loadConfig() completed!`);
    console.trace('Config access stack trace:');
  }
};


// Main config object - now pulls from runtime config first, falls back to build-time
export const Config = {
  get API_BASE_URL() { 
    checkConfigLoaded('API_BASE_URL');
    return runtimeConfig?.API_BASE_URL || process.env.REACT_APP_API_BASE_URL || process.env.API_BASE_URL; 
  },
  get APP_BASE_URL() { 
    checkConfigLoaded('APP_BASE_URL');
    // return runtimeConfig?.APP_BASE_URL || process.env.REACT_APP_APP_BASE_URL; 
    return runtimeConfig?.APP_BASE_URL; 
  },
  get AUTH0_AUDIENCE() { 
    checkConfigLoaded('AUTH0_AUDIENCE');
    return runtimeConfig?.AUTH0_AUDIENCE || process.env.REACT_APP_AUTH0_AUDIENCE; 
  },
  get AUTH0_CLIENT_ID() { 
    checkConfigLoaded('AUTH0_CLIENT_ID');
    return runtimeConfig?.AUTH0_CLIENT_ID || process.env.REACT_APP_AUTH0_CLIENT_ID; 
  },
  get AUTH0_DOMAIN() { 
    checkConfigLoaded('AUTH0_DOMAIN');
    return runtimeConfig?.AUTH0_DOMAIN || process.env.REACT_APP_AUTH0_DOMAIN; 
  },


  get imagePATH() { 
    checkConfigLoaded('imagePATH');
    // return runtimeConfig?.imagePATH || process.env.REACT_APP_IMAGE_BASE_URL; 
    return runtimeConfig?.imagePATH; 
  },
  get s3SecretKey() { 
    checkConfigLoaded('s3SecretKey');
    // return runtimeConfig?.s3SecretKey || process.env.REACT_APP_SECRET_KEY; 
    return runtimeConfig?.s3SecretKey; 
  },
  get s3Region() { 
    checkConfigLoaded('s3Region');
    // return runtimeConfig?.s3Region || process.env.REACT_APP_REGION; 
    return runtimeConfig?.s3Region; 
  },
  get s3BucketName() { 
    checkConfigLoaded('s3BucketName');
    // return runtimeConfig?.s3BucketName || process.env.REACT_APP_S3_BUCKET_NAME; 
    return runtimeConfig?.s3BucketName; 
  },
  get appAccessKey() { 
    checkConfigLoaded('appAccessKey');
    // return runtimeConfig?.appAccessKey || process.env.REACT_APP_ACCESS_KEY; 
    return runtimeConfig?.appAccessKey; 
  },
  get tinymceKey() {
    checkConfigLoaded('tinymceKey');
    return runtimeConfig?.TINYMCE_API_KEY || process.env.TINYMCE_API_KEY;
  },
  // get REACT_APP_API_KEY(){
  //   checkConfigLoaded('REACT_APP_API_KEY');
  //   return runtimeConfig?.REACT_APP_API_KEY || process.env.REACT_APP_API_KEY;
  // }
};
